// API configuration
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const mockSubmitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API}/forms/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    
    if (!response.ok) {
      throw new Error('Failed to submit form');
    }
    
    const data = await response.json();
    console.log('Contact form submitted:', data);
    
    return {
      success: true,
      message: data.message || 'Thank you for your inquiry. We will contact you within 24 hours.',
      data: formData
    };
  } catch (error) {
    console.error('Contact form submission error:', error);
    throw error;
  }
};

export const mockSubmitSampleRequest = async (formData) => {
  try {
    const response = await fetch(`${API}/forms/sample-request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    
    if (!response.ok) {
      throw new Error('Failed to submit sample request');
    }
    
    const data = await response.json();
    console.log('Sample request submitted:', data);
    
    return {
      success: true,
      message: data.message || 'Sample request received. We will prepare and ship your samples shortly.',
      data: formData
    };
  } catch (error) {
    console.error('Sample request submission error:', error);
    throw error;
  }
};

export const coffeeProducts = [
  {
    id: 1,
    name: 'Washed Premium Commercial Grade Arabica',
    shortName: 'Washed Arabica',
    defects: '25',
    grade: 'Selected Lots',
    description: 'Selected Venezuelan washed arabica lots with cleaner preparation and more refined commercial cup profiles. Depending on the lot, sensory notes may include citrus, orange, chocolate, caramel, brown sugar, and mild fruity acidity. Medium body with accessible sweetness and balanced structure.',
    characteristics: [
      'Screen size: 15+ (lot-dependent)',
      'Moisture: 10–12%',
      'Processing: Fully washed',
      'Cup profile: citrus, orange, chocolate, caramel, brown sugar'
    ],
    bestFor: [
      'Quality-focused blends requiring better-prepared origin coffees',
      'Selected roasting programs seeking elevated Venezuelan washed arabica',
      'Buyers seeking commercially accessible coffees with cleaner sensory presentation',
      'Importers testing Venezuelan coffee for future quality-driven programs'
    ],
    image: 'https://customer-assets.emergentagent.com/job_avila-coffee-export/artifacts/vz0vj651_Screenshot%202026-04-04%20at%2018.31.47.png'
  },
  {
    id: 2,
    name: 'Washed Commercial Grade Arabica',
    shortName: 'Washed Arabica',
    defects: '60',
    grade: 'Core Range',
    description: 'Reliable Venezuelan washed arabica for value-quality programs, blend development, and mainstream roasting applications. Typical cup profiles include cocoa, brown sugar, caramel, mild fruit, medium body, and balanced sweetness. Offers consistent quality-to-price positioning for buyers managing blend economics without sacrificing drinkability.',
    characteristics: [
      'Screen size: 14+',
      'Moisture: 10–12%',
      'Processing: Fully washed',
      'Cup profile: cocoa, brown sugar, caramel, mild fruit'
    ],
    bestFor: [
      'Espresso blends requiring dependable washed arabica with chocolatey profiles',
      'House blends for cafés and roasting programs',
      'Premium commercial roasting programs balancing quality and cost',
      'Importers and traders seeking workable Venezuelan washed arabica supply'
    ],
    image: 'https://customer-assets.emergentagent.com/job_avila-coffee-export/artifacts/vz0vj651_Screenshot%202026-04-04%20at%2018.31.47.png'
  }
];

export const cupProfiles = [
  {
    id: 1,
    name: 'Cocoa & Brown Sugar',
    description: 'Round, approachable coffees with chocolate-forward character, brown sugar sweetness, and mild fruity acidity. Medium body with balanced structure and wide application potential.',
    useCases: [
      'Espresso blends requiring chocolatey base and approachable profiles',
      'Commercial blends for café and retail roasting programs',
      'Medium-roast programs seeking classic washed arabica characteristics',
      'House coffees prioritizing drinkability and customer acceptance'
    ]
  },
  {
    id: 2,
    name: 'Citrus, Orange & Caramel',
    description: 'More expressive coffees with citrus brightness, orange-like fruit notes, and a cocoa-caramel base. Medium body with clean finish and moderate acidity, offering elevated sensory presentation within commercial accessibility.',
    useCases: [
      'Premium commercial blends requiring more complexity and brightness',
      'Quality-focused roasting programs seeking elevated Venezuelan profiles',
      'Buyers seeking liveliness and fruit expression without extreme acidity',
      'Selected single-origin or micro-lot trial roasts from Venezuelan origin'
    ]
  }
];

export const cacaoProducts = [
  {
    id: 1,
    name: 'Venezuelan Cacao',
    status: 'Coming Soon',
    description: 'Premium Venezuelan cacao sourcing currently in development. We are establishing partnerships with select cacao producers to bring you exceptional quality.',
    characteristics: [
      'Origin: Venezuelan haciendas',
      'Quality: Premium grade',
      'Processing: Fermented and dried',
      'Available: Q2 2026'
    ]
  }
];
